import React, {useState} from "react";
import {truncDetail} from "../../common/Utils";
import FadeComponent from "./FadeComponent";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

const ShowMore = ({
                    children,
                    previewLength = 8,
                    moreLabel = "Show more",
                    lessLabel = "Show less",
                  }) => {
  const [expanded, setExpanded] = useState(false);

  const text = String(children);
  const needsToggle = text.split(' ').length > previewLength;
  if (!needsToggle) {
    return <>{children}</>;
  }

  const preview = truncDetail(text, previewLength)

  return (
    <span>
      <Box component="span">
        <Fade in={!expanded} timeout={200} unmountOnExit>
          <Box component="span">
            <p style={{whiteSpace: 'pre-wrap'}}>
              {preview}
            </p>
          </Box>
        </Fade>
        <Fade in={expanded} timeout={200} unmountOnExit>
          <Box component="span">
            <p style={{whiteSpace: 'pre-wrap'}}>
              {text}
            </p>
          </Box>
        </Fade>
        {' '}
        <Button
          size="small"
          onClick={() => setExpanded((prev) => !prev)}
          sx={{
            minWidth: 0,
            p: 0,
            verticalAlign: "baseline",
          }}
        >
        {expanded ? lessLabel : moreLabel}
      </Button>
    </Box>
  </span>
  );
};

export default ShowMore;
